<template>
  <div class="flex flex-wrap mt-4">
    <div class="w-full mb-12 px-4">
      <card-list title="Oficinas" resource="oficinas" primaryKey="idoficina"
        :records="records" :meta="meta" :columns="columns" />
    </div>
  </div>
</template>
<script>
import CardList from "@/components/Cards/CardList.vue";
import OficinaService from "@/services/oficina.service";
import { oficina } from "@/models/oficina";

export default {
  components: {
    CardList,
  },

  data() {
    return {
      records: null,
      meta: {},
      columns: oficina.filter(column => column.showOnList)
    }
  },

  watch: {
    $route: {
      immediate: true,
      handler(/*to, from*/) {
        OficinaService.list(this.$route.query)
          .then((data) => {
            this.records = data.records;
            this.meta = data.meta;
          })
          .catch((response) => {
            console.log(response);
          });
      },
    },
  },
};
</script>
